import { render, staticRenderFns } from "./yearly-report-for-employee-pdf.vue?vue&type=template&id=5a975484&scoped=true&"
import script from "./yearly-report-for-employee-pdf.vue?vue&type=script&lang=ts&"
export * from "./yearly-report-for-employee-pdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a975484",
  null
  
)

export default component.exports